import { Box, Typography } from "@mui/material"
import { If } from "lib/@components/switch"

const SOURCE_LABELS = {
    "configured-attribute": "the configured Email Attribute",
    nameID: "the Name ID (Unique User Identifier)",
    "default-claim": "the standard email address claim",
    email: "the email attribute",
}

export function FailureRow({ failure }) {
    return (
        <Box sx={{ p: 1.5, border: 1, borderColor: "divider", borderRadius: 1 }} data-cy="sso-failure-row">
            <Typography variant="caption" color="text.secondary" display="block">
                {heading()}
            </Typography>
            <Typography variant="body2">{failure?.reason}</Typography>
            <If value={!!failure?.resolvedEmail}>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                    {identitySummary()}
                </Typography>
            </If>
            <If value={!!failure?.attributes?.length}>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                    sx={{ mt: 0.5, wordBreak: "break-all" }}
                >
                    Claims received: {failure?.attributes?.join(", ")}
                </Typography>
            </If>
        </Box>
    )

    function heading() {
        const when = failure?.at ? new Date(failure.at).toLocaleString() : ""
        return failure?.ref ? `${when} · ref ${failure.ref}` : when
    }

    function identitySummary() {
        const sourceLabel = SOURCE_LABELS[failure?.resolvedFrom] || failure?.resolvedClaim || "an unknown claim"
        const suffix = failure?.expectedEmail ? `; the user started sign-in as ${failure.expectedEmail}` : ""
        return `Email identity ${failure?.resolvedEmail} was taken from ${sourceLabel}${suffix}`
    }
}
